// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".infinite-container>.manual-loading{cursor:pointer;font-size:16px;font-weight:lighter;padding:5px;text-align:center}.infinite-container>.manual-loading.loading{filter:blur(1px)}.infinite-container>.offers-container{display:flex;flex-wrap:wrap;justify-content:space-between}.infinite-container>.offers-container .offer{margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
